module.exports = __webpack_public_path__ + "img/vuma-fibre-process-4.3c637fdb.svg";